import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { UserCourse, UserTopic } from 'src/app/Models/employeecareerUser-program.model';

@Component({
  selector: 'app-top-training-list-details',
  templateUrl: './top-training-list-details.component.html',
  styleUrls: ['./top-training-list-details.component.css']
})
 
export class TopTrainingListDetailsComponent implements OnInit {
  programDetails:any;
 
    programName: any;
    courseDetails: any;
    topicDetails: any;
  
    //employeeDetails: EmployeeModel;
    employeeId: Number;
    userId: number;
    progarmId: number;
  
    course: UserCourse;
  
    isCourses: boolean = true;
    isProgramCompleted: boolean = false;
    prerequisites: any;
  
    courseAttachments: any[] = [];
  
    attachments: any[] = [];
    tempTopic: any;
  
    programType: number;
    isProgramRequested: any;
  
    element: any;
    totalTopics: number;
    totalTopicLength: number;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<TopTrainingListDetailsComponent>
  ) 
  {
this.programDetails=this.data.programDetails;
  }
  ngOnInit(): void { 
     
        this.programName = this.data.programDetails?.programName; 
        this.isProgramCompleted = this.programDetails?.programStatus == 'Completed' ? true : false;
        this.prerequisites = this.programDetails?.courses.prerequisites;
        if (this.programDetails?.courses) {
          this.courseDetails = this.programDetails?.courses;
          this.totalTopics = 0;
          for (const course of this.courseDetails) {
            this.totalTopics += course.topics.length;
          }
          this.totalTopicLength = 0;
          for (const course of this.courseDetails) {
            for (const topic of course.topics) {
              this.totalTopicLength += topic.topicLength;
            }
          }
          this.courseAttachments = this.programDetails?.courses.attachments;
        }
  }
   goToTopics(course) {
    this.isCourses = false;
    this.topicDetails = course.topics;
    this.course = course;
    this.courseAttachments = course.attachments;
  }
  goToCourses() {
    this.course = null;
    this.isCourses = true;
  }

  onCancel() {
    this.dialogRef.close();
  }
}
